function discountSavingPrice(){
   let originalPrice = parseFloat($('.js-cw-product-page-form .js_product_var_change option:selected').attr('data-money_without-currency-price') * $('[name="product-count"]:checked').val()); // Get original price
   let discountPercentage = $('.js-cw-product-page-form [name="product-count"]:checked').attr('data-dis-per'); // Set discount percentage
   let discountAmount = (originalPrice * discountPercentage) / 100; // Calculate discount
   let finalPrice = originalPrice - discountAmount; // Subtract discount from original price
   let formattedDiscount = Shopify.formatMoney(discountAmount, $('body').data('money-format'));
   if(discountAmount != 0){
      $('.save--price').show();
      $('.save--price').html(`(${formattedDiscount} savings)`);
      }else{
         $('.save--price').hide();
      }
   $('.product--price').text(Shopify.formatMoney(finalPrice, $('body').data('money-format')));
}

function hasSubscriptionPlan(currentCartData) {
    if (
        !currentCartData || 
        !Array.isArray(currentCartData.items) || 
        currentCartData.items.length === 0
    ) {
        return false;
    }

    return currentCartData.items.some(item => {
        const planAlloc = item.selling_plan_allocation; // Shopify uses snake_case
        const sellingPlan = planAlloc && planAlloc.selling_plan;

        return (
            sellingPlan &&
            typeof sellingPlan.id !== 'undefined' &&
            sellingPlan.id !== null &&
            String(sellingPlan.id).trim() !== ''
        );
    });
}

$(document).ready(function () {
   
   $(document).on('click', '.eq-pdp-choice--atc', function (e) {
      e.preventDefault();
      let parent = $(this).closest('.eq-box');
      let variantId = parent.find('.eq-pdp-choice--atc').attr('data-variant-id');
      let qty = 1;
      let data = {};
      let subscriptionRadioLength = parent.find('.eq-subscripiton-widget:checked').length;
      if (subscriptionRadioLength > 0) {
         let sellingPlanId = parent.find('.selling-plan--selector option:selected').val();
         data = {
            id: variantId,
            quantity: qty,
            selling_plan: sellingPlanId
         };
      } else {
         data = {
            id: variantId,
            quantity: qty
         };
      }
      $.ajax({
         url: "/cart/add.js",
         method: "POST",
         data: data,
         dataType: "json",
         success: function (data) {
            // window.location = "/cart";
                 window.upcartOnCartLoaded = (cart) => {
                  var itemCount = cart.item_count;
               
                  $('.eq-header__icon-count').text(itemCount);
               
                  if (hasSubscriptionPlan(cart)) {
                  $(`.upcart-rewards-bar-foreground.styles_Rewards__progressBar--progress__`).css('width', '100%');
                  $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('background-color', '#b8948b');
                  $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('fill', '#e2e2e2');
                  $('.upcart-rewards-message').html(`🎉 Congrats! You've unlocked <strong>FREE SHIPPING!</strong>`);
                  // alert('Subscription item is in the cart.');
                  }
               };

         },
         error: function (xhr, status, error) {
            console.error("Error adding to cart:", error);
            console.error("Response Text:", xhr.responseText);
            window.alert(xhr.responseJSON.description);
         }
      });
   });

   $(document).on('change', '.eq-choice--radio', function (e) {
      let parent = $(this).closest('.eq-box');
      let widgetType = parent.find('.eq-choice--radio:checked').attr('data-widget-type');
      let subPrice = parent.find('.eq-choice--radio:checked').attr('data-price');
      if (widgetType == 'subscribe-save') {
         parent.find('.eq-pdp-choice--atc .price').html(subPrice);
      } else {
         parent.find('.eq-pdp-choice--atc .price').html(subPrice);
      }
   });

   $(document).on('change', `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2],.js-cw-product-page-form [data-option-3]`, function (e) {
      let option1 = option2 = option3 = null;
      let inputType = $(this).attr('data-input-type');
      if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
         if (inputType == 'radio') {
            option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();
         } else {
            option1 = $(`.js-cw-product-page-form [data-option-1] option:selected`).val();
         }
      }
      if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
         if (inputType == 'radio') {
            option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
         } else {
            option2 = $(`.js-cw-product-page-form [data-option-2] option:selected`).val();
         }
      }
      if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
         if (inputType == 'radio') {
            option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
         } else {
            option3 = $(`.js-cw-product-page-form [data-option-3] option:selected`).val();
         }
      }
      let variant_id = null;
      let current_selected_option = null;
      if (option2 == null & option3 == null) {

         current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
         variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
      }
      if (option2 != null & option3 == null) {

         current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
         variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
      }
      if (option2 != null & option3 != null) {

         current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
         variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
      }
      if (variant_id == null) {
         $(`.pdp-atc-v2`).text("Unavailable");
         $(`.pdp-atc-v2`).css("pointer-events", "none");
         $(`.pdp-atc-v2`).css("opacity", "0.5");
         
         return true;
      }
      let price = $(current_selected_option).attr('data-price');
      let compare_at_price = $(current_selected_option).attr('data-compareat-price');
      let discount = $(current_selected_option).attr('data-discount');
      let itemQty = $(current_selected_option).attr('data-qty');
      let afterPayPrice = $(current_selected_option).attr('data-afterpayprice')
      let save = $(current_selected_option).attr('data-save');
      let is_available = $(current_selected_option).attr('data-available');
      let subscriptionPercentage = $(current_selected_option).attr('data-sub-per');
      let variantPrice = $(current_selected_option).attr('data-money_without-currency-price');
      let discountPrice = parseFloat((variantPrice * subscriptionPercentage) / 100);
      let subscriptionPrice = variantPrice - discountPrice;
      let savPercentage = $(current_selected_option).attr('data-save-per');
      let savePrice = $(current_selected_option).attr('data-save-price')
      let productSelctQty = $("input[name='product-count']:checked").val();
      let productPrice = variantPrice * productSelctQty;
      let subscription_save_3_month = $(current_selected_option).attr('data-sub-price-3-month') || '';
      let subscription_save_1_month = $(current_selected_option).attr('data-sub-price-1-month') || '';
      let bestByDate = $(current_selected_option).attr('data-best-by-date');
      let subscriptionNoticeTitle = $(current_selected_option).attr('data-subscription-notice-title');
      let subscriptionNoticeMessage = $(current_selected_option).attr('data-subscription-notice-message');
      $('.eq-subscribtion-no-longer-available__wrap p').html(bestByDate);
      $('.subscription-notice-title').html(subscriptionNoticeTitle);
      $('.subscription-notice-message').html(subscriptionNoticeMessage);
      $('.product--price').text(Shopify.formatMoney(productPrice, $('body').data('money-format')));
      $('.one-time-price').text(price);
      // $('.js_save_price').text(savePrice);
      if (subscription_save_3_month != '') {
         $('.subscription_3_month_price').text(subscription_save_3_month);
      }
      if (subscription_save_1_month != '') {
         $('.subscription_1_month_price').text(subscription_save_1_month);
      }
      $('.subscription-price').html(Shopify.formatMoney(subscriptionPrice, $('body').data('money-format')));
      $('.js_afterpay').attr('data-amount', price);
      $(`.js_after_pay`).attr('data-price', afterPayPrice);
      let setAfterPayPrice = $('.js_after_pay').attr('data-price');
      let dividaedPrice = (setAfterPayPrice / 4).toFixed(2);
      let subSavePrice = $(current_selected_option).attr('data-subscription-save');
      if (save != '') {
         $(`.js_save_price`).html('save ' + save);
         $(`.js_save_price_wrap`).show();
         $('.js_save_percentage').text(savPercentage);
         $('.eq-discount-offer--wrapper').show();
      } else {
         $(`.js_save_price_wrap`).hide();
         $('.eq-discount-offer--wrapper').hide();
      }
      $('.auto-renewal-price').html(Shopify.formatMoney(subscriptionPrice, $('body').data('money-format')));   
      $(`.js_after_pay`).html('$' + dividaedPrice);
      $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change');
      // $(`.js-cw-product-page-form .js-compare-price`).text(compare_at_price);
      $(`.product__info-container s`).text(compare_at_price);
      $(`.js-price`).text(price);
      $(`.js-compare-price`).text(price);
      $(`.js-otp--price`).text(price);
      $(`.js_sticky_price`).html(price);
      $(`.js_sticky_price`).html(price);
      if (compare_at_price) {
         $(`.js-compare-price`).html(compare_at_price);
         $(`.js_sticky_comprice`).html(compare_at_price);
         $(`.js-compare-price`).show();
         $(`.js_sticky_comprice`).show();
      } else {
         $(`.js-compare-price`).hide();
         $(`.js_sticky_comprice`).hide();
      }
      $(`.js-cw-product-page-form .js_discount`).text('Save ' + discount + '%');
      $(`.jsproqty`).text(itemQty);
      if (is_available == 'true') {
         $(`.pdp-atc-v2 .atc--text`).html(`<img src="//joyorganics.com/cdn/shop/files/eq-product-btn-cart-icon_30x.png?v=9807713154866607732" alt="cart icon" data-uw-rm-alt-original="cart icon" data-uw-rm-alt="ALT"> Add to Cart`);
         $(`.pdp-atc-v2`).css("pointer-events", "all");
         $(`.pdp-atc-v2`).css("opacity", "1");
      } else {
         $(`.pdp-atc-v2`).css("pointer-events", "none");
         $(`.pdp-atc-v2`).css("opacity", "0.5");
         $(`.pdp-atc-v2 .atc--text`).text("Soldout");
      }
      $("input[name='subscribe_save']:checked").trigger('change');
      if (!($('input[name="subscribe_save"]:checked').attr('id') === 'selling_plan_3_month' || $('input[name="subscribe_save"]:checked').attr('id') === 'selling_plan_1_month')) {
         $('.pdp-atc-v2 .save--price').text(`(${subSavePrice} saving)`);
      }
      //$('input[name="purchaseOption"]:checked').trigger('change');
      // Preserve ALL existing URL parameters when updating the variant.
      const newUrl = new URL(window.location.href);

      // Update only the variant parameter.
      newUrl.searchParams.set('variant', variant_id);

      // Preserve all other parameters, including:
      // utm_source, utm_medium, utm_campaign,
      // fbclid, gclid, custom parameters, etc.

      window.history.replaceState(
         window.history.state,
         '',
         newUrl.href
      );
      /*
      console.log(variant_id);
      console.log(price);
      console.log(compare_at_price);
      console.log(discount);
      console.log(image_src);
      console.log(save);
      */
   });
   $('.pdp-radio--option:checked').trigger('change');
   $('input[name="subscribe_save"]:checked').trigger('change');

   /* PDP bundle count changes start */ 
   $('[name="product-count"]').on('click', function() {
      discountSavingPrice();
   });
   /* PDP bundle count changes end */
});
 
$.fn.shadowFind = function (selector) {
   return $(this.get(0)?.shadowRoot?.querySelectorAll(selector));
};

$(document).ready(function () {
   const widget = document.querySelector("recharge-subscription-widget");
   if (!widget || !widget.shadowRoot) return;
   if (widget && widget.shadowRoot) {
      function attachListeners() {
         const inputs = widget.shadowRoot.querySelectorAll('input[type="radio"], input[type="checkbox"]');
         const checkedValue = widget.shadowRoot.querySelector("input:checked");
         if (checkedValue) {
            const value = checkedValue.value; // or checkedValue.getAttribute('value')
        
            if (value === "onetime") {
              
            } else if (value === "subscription") {
               $('.product--price').text($('.js_product_var_change option:selected').attr('data-sub-price'))
            }
        }
         inputs.forEach(input => {
            if (!input.dataset.listenerAttached) {  // Prevent duplicate event listeners
               input.dataset.listenerAttached = "true";
               input.addEventListener("change", function () {
                  let productSubPrice = $('.js_product_var_change option:selected').attr('data-sub-price');
                  let productOtpPrice = ($('.js_product_var_change option:selected').attr('data-money_without-currency-price') * $('input[name="product-count"]:checked').val());
                  const checkedInput = widget.shadowRoot.querySelector("input:checked");
                 
               });
            }
         });
      }

      // Attach initial event listeners
      attachListeners();

      // Observe shadow DOM for changes and reattach listeners if new elements appear
      const observer = new MutationObserver(() => {
         attachListeners();
      });

      observer.observe(widget.shadowRoot, { childList: true, subtree: true });
   }
});


function show_disc() {
  let originalPrice = parseFloat($('.js_product_var_change option:selected').attr('data-money_without-currency-price'));
  var discountPercentage = parseFloat($('.js_product_var_change option:selected').attr('data-sub-per'));
   let discountAmount = (originalPrice * discountPercentage) / 100; // Calculate discount
   let finalPrice = originalPrice - discountAmount; // Subtract discount from original price
   let formattedDiscount = Shopify.formatMoney(discountAmount, $('body').data('money-format'));
   var val = $('.rc-radio__input:checked').val();
}
function waitForElement(selector, callback, attempts = 0, maxAttempts = 30) {
  if ($(selector).length) {
    callback();
  } else if (attempts < maxAttempts) {
    setTimeout(() => waitForElement(selector, callback, attempts + 1, maxAttempts), 100);
  } else {
    console.warn(`Element ${selector} not found after ${maxAttempts} attempts.`);
  }
}
waitForElement('.rc-radio__input', show_disc);

$(document).on("change", ".rc-radio__input", function () {
   if ($(this).val() === "onetime") {
       $('.eq-product-detail-count').show();
      $('.product--price').text($('.js_product_var_change option:selected').attr('data-price'))
   }else{
     $('.product--price').text($('.js_product_var_change option:selected').attr('data-sub-price'))
     /* PDP bundle count changes start */ 
     // $('.eq-product-detail-count').hide();
     /* PDP bundle count changes end */
   }
  show_disc();
});


$(document).on('click', '.pdp-atc-v2', function (e) {
   e.preventDefault();

   let varId = $('.js-cw-product-page-form .js_product_var_change option:selected').val();
   let oneTimeqty = $('input[name="product-count"]:checked').val();
   let data = {}; // Declare the data object outside the conditional block
   let purchaseType = $(".js-cw-product-page-form input[name='subscribe_save']:checked").val();
   let discountCode = $('input[name="product-count"]:checked').attr('data-discount-code');
   let customFlavor = $('.js-cw-product-page-form select[name="custom-flavor"]').val();
   let customStrength = $('.js-cw-product-page-form .custom-meta-strength:checked').val();
  
   if (purchaseType == 'subscription') {
      let sellingPlanId = $('.js-cw-product-page-form .selling-plans__dropdown option:selected').val();
      var qty = 1, properties = {
            'Strength': customStrength,
            'Flavor': customFlavor
        };

      if ($('input[name="subscribe_save"]:checked').length > 0 && $('input[name="subscribe_save"]:checked').attr("id") === 'selling_plan_3_month') {
         sellingPlanId = $('input[name="subscribe_save"]:checked').attr('data-selling-plan-id');
         qty = 3;
         properties._3_month_selling = true;
      }
      if ($('input[name="subscribe_save"]:checked').length > 0 && $('input[name="subscribe_save"]:checked').attr("id") === 'selling_plan_1_month') {
         sellingPlanId = $('input[name="subscribe_save"]:checked').attr('data-selling-plan-id');
         qty = 1;
         properties._1_month_selling = true;
      }
      if ($('input[name="subscribe_save"]#selling_plan_3_month').length > 0) {
         var $block = $('input[name="subscribe_save"]#selling_plan_3_month')
            .closest('.subscribe-widget__block');

         if ($block.is(':visible')) {
            properties._3_month_selling = true;
         }
      }
      if ($('input[name="subscribe_save"]#selling_plan_1_month').length > 0) {
         var $block1Month = $('input[name="subscribe_save"]#selling_plan_1_month')
            .closest('.subscribe-widget__block');

         if ($block1Month.is(':visible')) {
            properties._1_month_selling = true;
         }
      }

      data = {
         id: varId,
         quantity: qty,
         selling_plan: sellingPlanId,
         properties: properties
      };
   } else {

      var properties = {
            'Strength': customStrength,
            'Flavor': customFlavor
        };

      // if ($('input[name="subscribe_save"]#selling_plan_3_month').length > 0) {
      //    var $block = $('input[name="subscribe_save"]#selling_plan_3_month')
      //       .closest('.subscribe-widget__block');

      //    if ($block.is(':visible')) {
      //       properties._3_month_selling = true;
      //    }
      // }

      if ($('.eq-product-detail-count').is(':visible')) {
         properties._isBunleProduct = true;
         data = {
            id: varId,
            quantity: oneTimeqty,
            properties: properties
         };
      } else {
         data = {
            id: varId,
            quantity: oneTimeqty,
            properties: properties
         };
      }


   }
   
   $.ajax({
      url: "/cart/add.js",
      method: "POST",
      data: data,
      dataType: "json",
      success: function (data) {
         
         if(discountCode != ''){ 
               $.ajax({
                  type: 'GET',
                  url: '/discount/' + discountCode,
                  success: function(discountResponse) {
                     window.upcartRefreshCart();
                  },
                  error: function(xhr, status, error) {
                     console.error('Error applying discount:', error);
                  }
            });
         }

          // Accessibility confirmation for JAWS
            var $announcement = $('<div>', {
               role: 'alert',
               'aria-atomic': 'true',
               text: 'Product has been added to your cart.'
            }).css({
               position: 'fixed',
               width: '1px',
               height: '1px',
               padding: '0',
               margin: '-1px',
               overflow: 'hidden',
               clip: 'rect(0, 0, 0, 0)',
               whiteSpace: 'nowrap',
               border: '0'
            });

            $('body').append($announcement);

            // Give JAWS time to detect the element
            setTimeout(function () {
               //$announcement.attr('tabindex', '-1');
               $announcement.focus();
            }, 100);

            // Remove it after announcement
            setTimeout(function () {
               $announcement.remove();
            }, 2000);
              window.upcartOnCartLoaded = (cart) => {
                  var itemCount = cart.item_count;
                   var label = 'Cart, ' + itemCount + (itemCount === 1 ? ' item' : ' items');
                  $('.eq-header__icon-link[href="/cart"]').attr('aria-label', label);
                  $('.eq-header__icon-count').text(itemCount);
               
                  if (hasSubscriptionPlan(cart)) {
                  $(`.upcart-rewards-bar-foreground.styles_Rewards__progressBar--progress__`).css('width', '100%');
                  $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('background-color', '#b8948b');
                  $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('fill', '#e2e2e2');
                  $('.upcart-rewards-message').html(`🎉 Congrats! You've unlocked <strong>FREE SHIPPING!</strong>`);
                  // alert('Subscription item is in the cart.');
                  }
               };
          
         // window.location = "/cart";
      },
      error: function (xhr, status, error) {
         console.error("Error adding to cart:", error);
         console.error("Response Text:", xhr.responseText);
         window.alert(xhr.responseJSON.description);
      }
   });

});



$('.boost-wellness p').filter(function() {
   return $(this).text().trim() === '';
}).remove();

$(document).ready(function () {
   var checkedValue = $('.rc-radio__input:checked').val();
   if (checkedValue === "onetime") {
      $('.eq-product-detail-count').show();
      $('.recharge-inner-most-price').text($('.js_product_var_change option:selected').attr('data-price'));
  }else{
     $('.recharge-inner-most-price').text($('.js_product_var_change option:selected').attr('data-sub-price'));
     /* PDP bundle count changes start */ 
     // $('.eq-product-detail-count').hide();
     /* PDP bundle count changes end */
  }
});
$(document).on('click', '.js_write_review_btn', function (e) {
  e.preventDefault();
  $('#yotpo-main-widget-btn').trigger('click');
});


$(document).ready(function () {
   let productForSlideFancy = $('[data-fancybox="productForSlider"]');
   if(productForSlideFancy){
     productForSlideFancy.fancybox({
       wheel: false, // Disable the mouse scroll wheel for changing slides
       loop: false,            // Enable looping of the gallery
       autoplay: false,        // Enable autoplay for slideshows
       arrows: true,          // Enable navigation arrows
       infobar: true,         // Show the information bar
       toolbar: true,         // Show the toolbar
       smallBtn: false,        // Show the small close button
       keyboard: true,        // Enable keyboard navigation
       touch: true,           // Enable touch swipe gestures
       animationEffect: 'fade',  // Use fade effect for opening/closing
       transitionEffect: 'slide', // Use slide transition between items
       thumbs: false,          // Enable thumbnails navigation
       idleTime: 3000,        // Set idle time before gallery auto-closes
       closeClick: true,       // Close gallery when clicking outside
       buttons: [
         'close',
       ]
     });    
   }
   
   function waitForElement(selector, callback) {
      const interval = setInterval(() => {
          const element = document.querySelector(selector);
          if (element) {
              clearInterval(interval);
              callback(element);
          }
      }, 100);
  }
  
  // Usage
  waitForElement('.rc-widget', (element) => {
   //   $('input[name="option-Strength"]:checked').trigger('change');
   //   $('input[name="option-Flavor"]:checked').trigger('change');
   //   $('input[name="purchaseOption"]:checked').trigger('change');
  });

 });

 $(document).on("change", '[name="subscribe_save"]', function (e) {
   e.preventDefault();
   let selectedOption = $('.js-cw-product-page-form .js_product_var_change option:selected');
   let moneyFormat = $('body').data('money-format');
   let subScripitonPrice = selectedOption.attr('data-sub-price');
   let oneTimePrice = selectedOption.attr('data-price');
   let subscriptionSave = selectedOption.attr('data-subscription-save');
   if ($('input[name="subscribe_save"]:checked').length > 0 && $('input[name="subscribe_save"]:checked').attr("id") === 'selling_plan_3_month' && $(this).val() === 'subscription') {
      let rawPrice = parseFloat(selectedOption.attr('data-sub-price-3-month-raw')) * 3;
      let rawSave = parseFloat(selectedOption.attr('data-subscription-save-3-month-raw')) * 3;
      subScripitonPrice = Shopify.formatMoney(rawPrice, moneyFormat);
      subscriptionSave = Shopify.formatMoney(rawSave, moneyFormat);
   } 
   if ($('input[name="subscribe_save"]:checked').length > 0 && $('input[name="subscribe_save"]:checked').attr("id") === 'selling_plan_1_month' && $(this).val() === 'subscription') {
      subScripitonPrice = selectedOption.attr('data-sub-price-1-month');
      subscriptionSave = selectedOption.attr('data-subscription-save-1-month');
   }
   if ($(this).val() === 'subscription') {
      $('.product--price').text(subScripitonPrice);
      $('.save--price').text(`(${subscriptionSave} savings)`);
      $('.save--price').show();
    } else {
      $('.product--price').text(oneTimePrice);
      $('.save--price').hide();
    }
 });
 document.addEventListener('DOMContentLoaded', function () {

   const benefitsList = document.querySelectorAll('.subscribe-widget__benefits li');
   const toggleBtn = document.querySelector('.watch-more__benefits-text');

    function updateList(showAll) {
        benefitsList.forEach((item, index) => {
            if (index > 2) {
                if (showAll) {
                  item.classList.remove('is-hidden-points');
               } else {
                  item.classList.add('is-hidden-points');
               }
            }
        });
        toggleBtn.textContent = showAll ? '- less' : '+ more';
    }

    // Initial setup: hide all beyond the first 3
    updateList(false);

    toggleBtn.addEventListener('click', function () {
        const showingAll = toggleBtn.textContent.toLowerCase() === '- less';
        updateList(!showingAll);
    });

    window.onload = () => {
      updateList(false);  // Hide all items beyond the first 3 on load
  };

  window.upcartSubscribeCartUpdated((cartData) => {
   setTimeout(function () {
       const currentCartData = upcartGetCart();

    if (!currentCartData || !Array.isArray(currentCartData.items)) {
        console.warn('Invalid or empty cart data:', currentCartData);
        return;
    }

    const result = hasSubscriptionPlan(currentCartData);
    currentCartData.items.forEach((item, index) => {
        const planAlloc = item.sellingPlanAllocation;
        const sellingPlan = planAlloc && planAlloc.sellingPlan;

        if (sellingPlan && sellingPlan.id) {
            $(`.upcart-rewards-bar-foreground.styles_Rewards__progressBar--progress__`).css('width', '100%');
            $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('background-color', '#b8948b');
           $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('fill', '#e2e2e2');
           $(`.upcart-rewards-message`).html(`🎉 Congrats! You've unlocked <strong>FREE SHIPPING!</strong>`);
        } else {
            console.log(`has no valid selling plan.`);
        }
    });
      }, 800); 
  });
// Run when UpCart drawer opens
window.upcartSubscribeCartOpened(() => {
    const currentCartData = upcartGetCart();

    if (!currentCartData || !Array.isArray(currentCartData.items)) {
        console.warn('Invalid or empty cart data:', currentCartData);
        return;
    }

    const result = hasSubscriptionPlan(currentCartData);
    currentCartData.items.forEach((item, index) => {
        const planAlloc = item.sellingPlanAllocation;
        const sellingPlan = planAlloc && planAlloc.sellingPlan;

        if (sellingPlan && sellingPlan.id) {
            $(`.upcart-rewards-bar-foreground.styles_Rewards__progressBar--progress__`).css('width', '100%');
            $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('background-color', '#b8948b');
           $(`.upcart-rewards-tier-circle.styles_TieredRewards__tierCircle__`).css('fill', '#e2e2e2');
           $(`.upcart-rewards-message`).html(`🎉 Congrats! You've unlocked <strong>FREE SHIPPING!</strong>`);
        } else {
            console.log(`has no valid selling plan.`);
        }
    });
});

});

$(document).on('change', '.selling-plans__dropdown', function () {
    const selectedOption = $('.js-cw-product-page-form .selling-plans__dropdown option:selected').text();;
    $('.auto-renewal-freq').text(selectedOption)
});
$(document).ready(function () {
    const selectedOption = $('.js-cw-product-page-form .selling-plans__dropdown option:selected').text();
    const selectOptPrice = $('.js-cw-product-page-form .js_product_var_change option:selected').attr('data-sub-price');
    $('.auto-renewal-freq').text(selectedOption);
    $('.auto-renewal-price').text(selectOptPrice);
});

$(document).on('click', '.coupon', function () {
  const $this = $(this);
  const couponCode = $this.attr('data-coupon');
  const originalHtml = $this.html();
  $this.css('width', $this.outerWidth());

  navigator.clipboard.writeText(couponCode).then(() => {
    $this.html('COPIED!');
    setTimeout(() => {
      $this.html(originalHtml);
      $this.css('width', '');
    }, 500);
  });

});